module.exports = __webpack_public_path__ + "img/down.aa544e29.svg";